import { Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLoginScreenStyle } from '../hooks/useLoginScreenStyleHook'
import LoginInputField from '../LoginInputField'
import InputErrorPopUp from '../InputErrorPopUp'
import { useLogInMenuHook } from '@/pages/loginScreen/hooks/useLogInMenuHook'

interface Props {
    handleBackToLogin: () => void
}

const ResetPasswordMenu = ({ handleBackToLogin }: Props) => {
    const {
        underLineButtonStyle,
        colorButtonStyle,
        subtitle2Style,
        buttonContainerStyles,
        inputContainerStyle,
    } = useLoginScreenStyle()

    const { t: translate } = useTranslation()
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const { resetPassword } = useLogInMenuHook()

    const handleResetPassword = async () => {
        if (!email) {
            setError(translate('emailFieldCannotBeEmpty') as string)
            return
        }

        try {
            await resetPassword(email)
            setError('')
        } catch (err) {
            console.error(err)
            setError(translate('resetPasswordFailed') as string)
        }
    }

    const handleEmailChange = (newEmail: string) => {
        setEmail(newEmail)
        setError('')
    }

    return (
        <>
            <Typography sx={subtitle2Style}>
                {translate('resetPasswordMessage')}
            </Typography>

            <Box sx={inputContainerStyle}>
                <LoginInputField
                    placeholder={'email'}
                    inputValue={email}
                    setInputValue={handleEmailChange}
                    defaultValue=""
                />
                <InputErrorPopUp
                    styles={{
                        position: 'absolute',
                        top: '40px',
                        width: 'max-content',
                    }}
                    errorMessage={error}
                />
            </Box>

            <Box sx={buttonContainerStyles}>
                <Button sx={colorButtonStyle} onClick={handleResetPassword}>
                    {translate('resetPasswordButtonText')}
                </Button>
            </Box>

            <Button
                sx={underLineButtonStyle}
                disableRipple
                onClick={handleBackToLogin}>
                {translate('backToLoginText')}
            </Button>
        </>
    )
}

export default ResetPasswordMenu
